export default __webpack_public_path__ + "static/tampines-town-council-logo-59424153ae82e2beb37294f8289e81f2.png";